<script lang="ts">
  import { between } from 'polished'

  export let cssCalc = between('1.8rem', '2.4rem', '32rem', '72rem')
  export let href: string
</script>

<a {href} target="_blank" rel="noopener" style="--interpolation:{cssCalc}">
  <slot />
</a>

<style>
  a {
    font-family: var(--body-font);
    font-weight: 300;
    font-size: clamp(1.8rem, var(--interpolation), 2.4rem);
    text-decoration-line: underline;
    text-decoration-style: dotted;
    text-decoration-color: var(--color-underscore);
    color: var(--color-callout);
  }
  a:hover {
    text-decoration-color: var(--primary-color);
  }
</style>
